import { render, staticRenderFns } from "./DailyPgFeeChart.vue?vue&type=template&id=1147a514&scoped=true&lang=pug"
import script from "./DailyPgFeeChart.vue?vue&type=script&lang=ts"
export * from "./DailyPgFeeChart.vue?vue&type=script&lang=ts"
import style0 from "./DailyPgFeeChart.vue?vue&type=style&index=0&id=1147a514&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1147a514",
  null
  
)

export default component.exports